/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Sets a value in a nested object or array based on a path string.
 * @param data - The object or array to modify.
 * @param path - The path to the value to set, using dot notation.
 * @param value - The value to set.
 * @returns A new object or array with the value set.
 */
export function setData<T extends Record<string, any>>(data: T | undefined, path: string, value: any): T {
  if (!path) return data as T;

  const copy = data ? structuredClone(data) : {} as T;
  const parts = path.split('.');
  let current: any = copy;

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    const isLast = i === parts.length - 1;

    if (isLast) {
      if (part === 'push' && Array.isArray(current)) {
        current.push(value);
      } else if (part === 'delete' && Array.isArray(current)) {
        if (Array.isArray(value)) {
          value.forEach((index) => current.splice(index, 1));
        }
      } else {
        current[part] = value;
      }
    } else {
      const nextPart = parts[i + 1];
      const shouldBeArray = !isNaN(Number(nextPart)) || nextPart === 'push';

      if (!(part in current) || current[part] === null || current[part] === undefined) {
        current[part] = shouldBeArray ? [] : {};
      }

      current = current[part];
    }
  }

  return copy;
}
